var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtpConfirmation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 299,
    viewBox: "0 0 299 299",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204.516 231.426C204.516 231.426 233.22 229.632 252.954 194.35C272.688 159.068 269.1 105.248 244.582 75.3479C220.064 45.4479 181.792 35.2819 145.314 44.8499C127.541 49.5083 115.689 61.5939 105.445 76.1731C96.5231 88.8746 86.4886 101.11 72.9858 109.147C59.6145 117.1 45.8665 123.451 39.1151 138.568C22.682 175.381 34.6839 218.198 73.5539 232.622C115.414 248.17 185.38 239.798 204.516 231.426Z",
    fill: "#F15E22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M204.516 231.426C204.516 231.426 233.22 229.632 252.954 194.35C272.688 159.068 269.1 105.248 244.582 75.3479C220.064 45.4479 181.792 35.2819 145.314 44.8499C127.541 49.5083 115.689 61.5939 105.445 76.1731C96.5231 88.8746 86.4886 101.11 72.9858 109.147C59.6145 117.1 45.8665 123.451 39.1151 138.568C22.682 175.381 34.6839 218.198 73.5539 232.622C115.414 248.17 185.38 239.798 204.516 231.426Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M152.592 257.75C209.011 257.75 254.748 253.734 254.748 248.78C254.748 243.826 209.011 239.81 152.592 239.81C96.1725 239.81 50.4355 243.826 50.4355 248.78C50.4355 253.734 96.1725 257.75 152.592 257.75Z",
    fill: "#F15E22"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M152.592 257.75C209.011 257.75 254.748 253.734 254.748 248.78C254.748 243.826 209.011 239.81 152.592 239.81C96.1725 239.81 50.4355 243.826 50.4355 248.78C50.4355 253.734 96.1725 257.75 152.592 257.75Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4199 135.328V140.632",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0748 137.982H45.7705",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M229.417 89.8794V95.1837",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M232.066 92.5347H226.762",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M154.068 48.8208V54.1251",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M156.717 51.4697H151.413",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7607 194.733V200.037",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4097 197.382H64.1055",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M227.042 70.7613C227.044 71.6297 226.787 72.4789 226.305 73.2015C225.824 73.9241 225.139 74.4876 224.337 74.8207C223.535 75.1539 222.652 75.2416 221.8 75.073C220.949 74.9043 220.166 74.4867 219.551 73.8731C218.937 73.2595 218.518 72.4774 218.348 71.6258C218.179 70.7742 218.265 69.8913 218.597 69.0889C218.929 68.2865 219.492 67.6006 220.214 67.1181C220.936 66.6355 221.785 66.3779 222.653 66.3779C223.816 66.3779 224.932 66.8396 225.755 67.6614C226.578 68.4833 227.041 69.5982 227.042 70.7613Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3518 176.079C41.5884 175.152 42.6505 172.588 41.7241 170.352C40.7976 168.115 38.2335 167.053 35.9969 167.979C33.7604 168.906 32.6983 171.47 33.6247 173.706C34.5511 175.943 37.1152 177.005 39.3518 176.079Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M246.974 115.611C246.984 115.749 246.967 115.887 246.921 116.017C246.876 116.147 246.805 116.266 246.711 116.367C246.618 116.468 246.504 116.549 246.378 116.604C246.252 116.659 246.116 116.687 245.978 116.687C245.84 116.687 245.704 116.659 245.578 116.604C245.452 116.549 245.339 116.468 245.245 116.367C245.152 116.266 245.08 116.147 245.035 116.017C244.99 115.887 244.972 115.749 244.982 115.611C245.002 115.361 245.115 115.126 245.3 114.956C245.484 114.785 245.727 114.69 245.978 114.69C246.23 114.69 246.472 114.785 246.656 114.956C246.841 115.126 246.954 115.361 246.974 115.611Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M94.884 101.259C94.8852 101.457 94.8276 101.651 94.7186 101.816C94.6096 101.981 94.4541 102.11 94.2717 102.186C94.0893 102.263 93.8883 102.283 93.6942 102.245C93.5001 102.208 93.3216 102.113 93.1813 101.974C93.0411 101.834 92.9454 101.656 92.9063 101.462C92.8673 101.268 92.8868 101.067 92.9622 100.884C93.0376 100.702 93.1656 100.545 93.3299 100.435C93.4943 100.325 93.6876 100.267 93.8854 100.267C94.1492 100.267 94.4023 100.371 94.5894 100.557C94.7765 100.743 94.8824 100.995 94.884 101.259Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M203.852 67.0239H111.521C109.292 67.0239 107.484 68.8311 107.484 71.0604V243.936C107.484 246.166 109.292 247.973 111.521 247.973H203.852C206.081 247.973 207.889 246.166 207.889 243.936V71.0604C207.889 68.8311 206.081 67.0239 203.852 67.0239Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M200.665 67.0239H108.333C106.104 67.0239 104.297 68.8311 104.297 71.0604V243.936C104.297 246.166 106.104 247.973 108.333 247.973H200.665C202.894 247.973 204.701 246.166 204.701 243.936V71.0604C204.701 68.8311 202.894 67.0239 200.665 67.0239Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1165_732",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 104,
    y: 67,
    width: 101,
    height: 181
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M200.665 67.0239H108.333C106.104 67.0239 104.297 68.8311 104.297 71.0604V243.936C104.297 246.166 106.104 247.973 108.333 247.973H200.665C202.894 247.973 204.701 246.166 204.701 243.936V71.0604C204.701 68.8311 202.894 67.0239 200.665 67.0239Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1165_732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.701 135.304L116.412 247.979H200.67C201.74 247.977 202.765 247.551 203.521 246.794C204.276 246.038 204.701 245.012 204.701 243.942V135.304Z",
    fill: "#F15E22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M204.701 135.304L116.412 247.979H200.67C201.74 247.977 202.765 247.551 203.521 246.794C204.276 246.038 204.701 245.012 204.701 243.942V135.304Z",
    fill: "white"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M200.665 67.0239H108.333C106.104 67.0239 104.297 68.8311 104.297 71.0604V243.936C104.297 246.166 106.104 247.973 108.333 247.973H200.665C202.894 247.973 204.701 246.166 204.701 243.936V71.0604C204.701 68.8311 202.894 67.0239 200.665 67.0239Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M161.46 77.8359H148.961C148.62 77.8359 148.293 77.7005 148.052 77.4594C147.811 77.2182 147.676 76.8912 147.676 76.5502C147.676 76.3817 147.709 76.2148 147.774 76.0591C147.838 75.9035 147.933 75.7621 148.053 75.6432C148.172 75.5243 148.314 75.4302 148.47 75.3662C148.626 75.3023 148.793 75.2697 148.961 75.2705H161.46C161.799 75.2705 162.125 75.4053 162.365 75.6453C162.605 75.8853 162.739 76.2108 162.739 76.5502C162.74 76.7188 162.708 76.8859 162.644 77.0418C162.58 77.1978 162.486 77.3395 162.367 77.459C162.248 77.5785 162.106 77.6733 161.951 77.738C161.795 77.8026 161.628 77.8359 161.46 77.8359Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M198.356 231.803H110.63V77.9854H131.422L133.761 79.9229C134.577 80.6025 135.605 80.9749 136.667 80.9754H173.354C174.455 80.9709 175.518 80.5672 176.344 79.8391L178.461 77.9854H198.356V231.803Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M127.099 198.638H181.899",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M127.099 205.85H181.899",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M127.099 213.062H181.899",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M132.157 131.68C128.713 136.67 127.041 142.67 127.407 148.722C127.773 154.774 130.157 160.529 134.178 165.068C138.198 169.606 143.624 172.666 149.588 173.759C155.552 174.852 161.71 173.915 167.079 171.098C172.447 168.28 176.717 163.745 179.206 158.216C181.695 152.687 182.259 146.484 180.809 140.597C179.358 134.709 175.977 129.478 171.204 125.738C166.432 121.998 160.544 119.966 154.481 119.965C152.818 119.965 151.159 120.115 149.523 120.413",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M136.78 126.555C135.869 127.343 135.01 128.19 134.209 129.09",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M175.67 156.106C180.65 144.414 175.209 130.899 163.516 125.919C151.824 120.939 138.308 126.38 133.329 138.072C128.349 149.765 133.79 163.28 145.482 168.26C157.175 173.24 170.69 167.799 175.67 156.106Z",
    fill: "#F15E22"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M143.872 144.698L152.603 154.619L166.883 134.389",
    stroke: "#263238",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M176.368 79.8391C175.542 80.5672 174.479 80.9709 173.378 80.9754H136.679C135.617 80.9749 134.589 80.6025 133.772 79.9229L131.434 77.9854H110.63V93.7187H198.356V77.9854H178.485L176.368 79.8391Z",
    fill: "#F15E22",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M157.303 236.545C157.304 236.149 157.188 235.762 156.969 235.433C156.75 235.104 156.438 234.847 156.073 234.695C155.708 234.543 155.306 234.503 154.918 234.58C154.53 234.656 154.173 234.847 153.894 235.127C153.614 235.406 153.424 235.763 153.347 236.151C153.27 236.539 153.31 236.941 153.462 237.306C153.614 237.671 153.871 237.983 154.2 238.202C154.529 238.421 154.916 238.537 155.312 238.536C155.84 238.535 156.345 238.324 156.718 237.951C157.091 237.578 157.302 237.072 157.303 236.545Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2828 175.37L71.4609 245.336C71.4609 245.336 65.7261 250.323 66.2284 252.338C66.7308 254.354 73.3506 251.142 74.2656 249.48C74.9149 248.096 75.3774 246.632 75.641 245.127L92.1099 192.503L104.776 248.936C104.776 248.936 110.158 253.355 113.148 253.205C116.138 253.056 115.073 251.878 113.369 249.719C111.664 247.56 107.807 246.328 107.807 246.328L105.906 173.594L79.2828 175.37Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M105.477 172.37L79.1992 173.706L79.3814 177.289L105.659 175.953L105.477 172.37Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5004 174.646C95.5423 175.537 94.4121 176.314 92.9649 176.392C91.5178 176.47 90.2979 175.812 90.2979 174.915C90.2979 174.018 91.3922 173.247 92.8334 173.175C94.2746 173.103 95.4526 173.761 95.5004 174.646Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9981 137.881L81.1191 140.775L82.345 173.797L105.518 173.223L102.587 139.089L90.9981 137.881Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6741 138.252L85.3466 194.601L72.7646 188.508L78.2961 170.711L74.5228 140.662L86.6741 138.252Z",
    fill: "#F15E22",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6787 137.744L103.711 193.669L115.617 186.331L108.31 169.187L109.015 138.91L96.6787 137.744Z",
    fill: "#F15E22",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1924 144.561L91.1538 147.754L89.5871 169.988L93.3066 174.389L95.2322 169.103L92.2541 147.796L94.09 144.71L91.4229 141.254L89.1924 144.561Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6199 144.136L87.9182 146.923L84.9521 139.687L86.6206 137.104L95.6803 136.643L97.8211 139.531L96.057 146.109L91.6199 144.136Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M87.374 134.323L88.2052 138.921L91.6198 144.136L94.7474 137.988L94.55 134.107L87.374 134.323Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M74.523 140.662L57.7432 160.976L68.8959 174.18L73.3868 171.261L67.8733 160.013L76.1018 154.057L74.523 140.662Z",
    fill: "#F15E22",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3865 171.261L74.0562 172.72L70.2769 174.861L69.7686 173.689L73.3865 171.261Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0563 172.721L77.9074 177.768L76.6396 179.329L75.7187 178.928L73.8529 180.519C73.8529 180.519 72.4895 180.136 72.3161 179.699C72.1427 179.263 70.2948 178.151 70.253 177.409C70.2111 176.668 70.253 174.862 70.253 174.862L74.0563 172.721Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M118.363 142.874C118.59 142.282 118.64 141.635 118.506 141.015C118.231 140.303 117.621 137.839 117.741 137.026C117.861 136.213 119.092 135.029 119.2 133.976C119.308 132.924 119.2 131.961 119.2 131.393C119.21 131.237 119.27 131.089 119.371 130.97C119.472 130.852 119.608 130.769 119.76 130.734C119.912 130.699 120.071 130.714 120.213 130.777C120.356 130.839 120.475 130.946 120.552 131.082C121.15 131.776 121.508 132.487 121.221 133.223C121.026 134.045 120.933 134.889 120.946 135.734C120.946 135.734 121.903 137.056 122.429 137.917C122.955 138.778 122.908 141.033 122.555 141.936C122.226 142.619 121.762 143.23 121.191 143.73L121.251 145.284L118.363 142.874Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M120.109 134.49C120.109 134.49 119.69 135.722 120.426 136.003C121.161 136.284 124.169 136.703 124.199 135.734C124.229 134.765 124.289 134.281 123.804 134.305C123.32 134.329 121.066 134.305 121.066 134.305C121.066 134.305 120.019 134.251 120.109 134.49Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M120.45 140.53C120.45 140.53 120.151 141.445 120.683 141.654C121.215 141.864 123.38 142.181 123.398 141.457C123.416 140.734 123.458 140.375 123.111 140.393C122.764 140.411 121.138 140.393 121.138 140.393C121.138 140.393 120.384 140.339 120.45 140.53Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M120.048 138.574C120.048 138.574 119.702 139.639 120.318 139.884C120.934 140.129 123.439 140.482 123.463 139.657C123.487 138.832 123.535 138.401 123.128 138.419C122.722 138.437 120.844 138.419 120.844 138.419C120.844 138.419 119.971 138.371 120.048 138.574Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M119.816 136.679C119.816 136.679 119.397 137.911 120.139 138.192C120.88 138.473 123.876 138.892 123.906 137.923C123.936 136.954 123.996 136.47 123.512 136.494C123.027 136.518 120.773 136.494 120.773 136.494C120.773 136.494 119.726 136.446 119.816 136.679Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M118.021 144.1L118.488 142.223L121.729 144.154L121.185 146.193L118.021 144.1Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M109.016 138.91L115.223 152.119L118.273 143.622L121.263 146.468L118.201 162.22C118.106 162.705 117.871 163.151 117.525 163.504C117.179 163.857 116.738 164.102 116.255 164.207C115.772 164.313 115.269 164.275 114.807 164.098C114.345 163.921 113.946 163.613 113.657 163.212L108.699 156.294L109.016 138.91Z",
    fill: "#F15E22",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4853 128.953C84.4853 128.953 83.2295 127.613 83.068 128.594C82.9065 129.575 83.4148 131.267 84.2042 131.871C84.9936 132.475 85.6872 131.476 85.6872 131.476L84.4853 128.953Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M96.356 128.349C96.356 128.349 97.4623 126.89 97.7314 127.847C98.0005 128.803 97.6536 130.544 96.93 131.225C96.2065 131.907 95.4111 130.98 95.4111 130.98L96.356 128.349Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M84.988 130.328L83.792 127.799C82.8294 126.444 82.1631 124.901 81.8365 123.272C81.2385 120.497 82.2252 118.189 83.481 117.477C84.1868 117.055 85.0201 116.898 85.8312 117.035C85.8312 117.035 86.0704 115.408 90.0172 114.045C93.964 112.681 98.2576 115.139 98.1918 116C98.1261 116.861 97.0736 117.244 97.0736 117.244C97.0736 117.244 100.147 118.38 99.035 119.833C98.3491 120.721 97.4615 121.432 96.4457 121.908C96.6686 122.641 96.8503 123.386 96.9899 124.139C97.1453 125.102 96.2782 129.24 96.2782 129.24L94.1553 123.421L87.4936 123.762C87.4936 123.762 87.0989 126.585 86.3933 127.589C85.9429 128.352 85.692 129.216 85.6637 130.101C85.6637 130.101 85.3528 131.165 84.988 130.328Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1723 119.815C86.1609 121.552 86.0351 123.286 85.7956 125.006C85.6515 125.963 85.1571 126.833 84.4082 127.446C84.4082 127.446 85.2574 131.387 86.3338 133.486C87.4102 135.585 89.6467 137.307 91.9011 137.074C94.1556 136.84 95.9556 134.281 96.1709 132.116C96.3862 129.952 95.3277 121.95 95.3277 121.95C95.3277 121.95 88.2833 123.188 86.1723 119.815Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7705 127.906C87.1296 127.694 87.535 127.572 87.9517 127.551C88.3685 127.53 88.784 127.611 89.1625 127.787",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6748 126.112C86.6748 126.112 86.8123 124.916 88.8097 124.809",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9902 124.546C92.4422 124.36 92.9415 124.325 93.4151 124.444C93.8886 124.564 94.3114 124.832 94.6214 125.209",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2911 126.477C91.2911 126.477 91.608 128.869 91.626 129.162C91.6439 129.455 92.6426 129.509 92.3735 130.119C92.1044 130.729 91.2373 131.375 90.5137 130.914",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4153 132.917C92.4153 132.917 91.6559 133.653 90.125 133.031",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9283 127.243C93.9283 127.685 93.7429 128.056 93.4678 128.068C93.1927 128.08 92.9535 127.733 92.9296 127.297C92.9057 126.86 93.115 126.489 93.3901 126.471C93.6651 126.453 93.8864 126.806 93.9283 127.243Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtpConfirmation);
export default __webpack_public_path__ + "static/media/otpConfirmation.4bb52394f91cb6552221f48a0bd553d7.svg";
export { ForwardRef as ReactComponent };